
import './OnboardFiles.scss'
import useUrlNavigation from '../../../../hooks/useUrlNavigation'
import useUrlParams from '../../../../hooks/useUrlParams'
import { get_navigator_button_by_dashboard } from '../Utils'
import { OnboardFolderIcon } from '../Svgs'
import UploadDownloadQueue from '../UploadDownloadQueue'
import { useState, useEffect } from 'react'
import CustomFilter from '../../../../../CommonComponents/custom_filter/CustomFilter'
import AllOnboardFiles from './AllOnboardFiles'
import useFiles from '../../../../hooks/useFiles'


const OnboardFiles = ({ typeOfAction, actionFileId, setTypeOfAction, setActionFileId, isReadOnlyActions = false }) => {
    const { tab_name, dashboard } = useUrlParams()
    const { navigate_to } = useUrlNavigation()
    const [selectedPayload, setSelectedPayload] = useState('Payload Server')
    const [allFilters, setAllFilters] = useState({})
    const [filteredOnboardFiles, setFilteredOnboardFiles] = useState<any[] | null>(null); //files in onboard
    const { allOnboardFiles, deleteDownloadFile, onBoardChangePriority, refreshQueue } = useFiles()


    //HANDLE FOLDER CLICK
    const handleFolderClick = (payloadKey: string) => {
        if (payloadKey === selectedPayload) return;
        setSelectedPayload(payloadKey);
        const searchTerm = allFilters['searchFilter'] || '';
        const filteredArray = filteredFiles(searchTerm, payloadKey); // pass payloadKey explicitly
        setFilteredOnboardFiles(filteredArray);
    };

    //SET THE INITIAL FOLDER AND PERSIST SEARCH FIELD
    useEffect(() => {
        // If there are no onboard files at all, clear filtered state
        if (!allOnboardFiles) {
            setFilteredOnboardFiles(null);
            return;
        }

        const availablePayloadKeys = Object.keys(allOnboardFiles);

        // If selectedPayload exists and still present in the map, apply filters for it
        if (selectedPayload && allOnboardFiles[selectedPayload]) {
            const searchTerm = allFilters['searchFilter'] || '';
            const filteredArray = filteredFiles(searchTerm, selectedPayload); // pass payloadKey explicitly
            setFilteredOnboardFiles(filteredArray);
            return;
        }

        // Selected payload is missing (e.g. its last file was deleted) or not set.
        // Choose a reasonable fallback payload: prefer 'Payload Server' if present, otherwise first key.
        if (availablePayloadKeys.length > 0) {
            const fallback = availablePayloadKeys.includes('Payload Server') ? 'Payload Server' : availablePayloadKeys[0];
            setSelectedPayload(fallback);
            const payloadMap = allOnboardFiles[fallback];
            setFilteredOnboardFiles(payloadMap ? Array.from(payloadMap.values()) : []);
        } else {
            // No payloads available -> clear selection and filtered list
            setSelectedPayload('');
            setFilteredOnboardFiles([]);
        }
    }, [allOnboardFiles, selectedPayload, allFilters]);


    //FILTER FILES WHEN SEARCHING
    const filteredFiles = (name = '', payloadKey?: string) => {
        const search = name.toLowerCase();

        const selectedKey = payloadKey || selectedPayload;
        if (!allOnboardFiles || !selectedKey) return [];

        const selectedMap = allOnboardFiles[selectedKey];
        if (!selectedMap) return [];

        const files = Array.from(selectedMap.values()) as any[];
        return files.filter(file => {
            const fileName = file.fileName?.toLowerCase() || '';
            const lastModified = file.updatedAt?.toLowerCase() || '';
            const fileBand = file.radioId?.toLowerCase() || '';
            return fileName.includes(search) || lastModified.includes(search) || fileBand.includes(search);
        });
    };

    //HANDLE FILTER OF GROUND FILES
    const handleOnBoardFilesFilters = (filters) => {
        const result = filteredFiles(filters?.searchFilter || '');
        setFilteredOnboardFiles(result);
    }

    return (
        <>
            <div className='onboard__files__contact__container'>
                <div className='d-flex gap-3 w-100'>
                    <div className='onboard__files__container__left__container__wrapper'>
                        <div className='onboard__files__container__header__container'>
                            {/* NAVIGATION BUTTONS */}
                            <div className='onboard__files__container__header__left__container'>
                                {dashboard && get_navigator_button_by_dashboard(dashboard).map((btn) => {
                                    return (
                                        <button
                                            className={`button ${tab_name === btn.name ? 'active' : ''}`}
                                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                e.stopPropagation()
                                                navigate_to(btn.name)
                                            }}
                                            key={btn.name}
                                        >
                                            {btn.label}
                                        </button>
                                    )
                                })}

                            </div>
                            <div className='onboard__files__container__header__right__container'>
                                {/* FILTER COMPONENT */}
                                <CustomFilter
                                    alignment='right'
                                    search={{
                                        applyFilter: (filters: { [key: string]: any }) => {
                                            handleOnBoardFilesFilters(filters)
                                        }
                                    }}
                                    allFilters={allFilters}
                                    setAllFilters={setAllFilters}
                                    filterCase={'file'}
                                    boundingScreen={'ground__files__container__left__container__wrapper'}
                                />
                            </div>
                        </div>
                        <div className='onboard__files__left__container__body'>
                            {/* PAYLOAD FOLDERS */}
                            <div className='onboard__folder__container'>
                                <div className='onboard__folder__container__body'>
                                    {allOnboardFiles &&
                                        Object.keys(allOnboardFiles).map((payloadKey) => (
                                            <div
                                                key={payloadKey}
                                                className={`onboard__folder__container__body__row cursor-pointer ${payloadKey === selectedPayload ? 'active' : ''}`}
                                                onClick={() => handleFolderClick(payloadKey)}
                                            >
                                                <div className='folder-icon'>
                                                    <OnboardFolderIcon />
                                                </div>
                                                <span className='folder-name'>{payloadKey}</span>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            {/* ALL FILES LIST */}
                            <AllOnboardFiles
                                isReadOnlyActions={isReadOnlyActions}
                                allOnboardFiles={filteredOnboardFiles}
                                setTypeOfAction={setTypeOfAction}
                                setActionFileId={setActionFileId}
                            />
                        </div>
                    </div>
                    {/* QUEUE COMPONENT */}
                    <UploadDownloadQueue
                        isReadOnlyActions={isReadOnlyActions}
                        type={'onboard'}
                        setActionFileId={setActionFileId}
                        setTypeOfAction={setTypeOfAction}
                    />
                </div>

            </div>
        </>
    )
}

export default OnboardFiles;